import { render, staticRenderFns } from "./AsiBreadcrumbsEntry.vue?vue&type=template&id=62b93606&scoped=true"
import script from "./AsiBreadcrumbsEntry.vue?vue&type=script&lang=ts"
export * from "./AsiBreadcrumbsEntry.vue?vue&type=script&lang=ts"
import style0 from "./AsiBreadcrumbsEntry.vue?vue&type=style&index=0&id=62b93606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b93606",
  null
  
)

export default component.exports